import { Component, Inject, Input, OnInit } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { CaseView } from 'src/app/digigov/models/caseview.model';

export class customData {
  selectedData: CaseView[];
  isFromCustomAction: boolean;
  isFromGrpWorklist: boolean;
  defaultData: boolean;
}

@Component({
  selector: 'app-dg-dispose',
  templateUrl: './dg-dispose.component.html',
  styleUrls: ['./dg-dispose.component.scss'],
})
export class DgDisposeComponent implements OnInit {
  @Input() caseData: CaseView[];
  checkDispose: boolean;
  docId: number;
  appTypeID: string;
  postData = [];
  str: string;
  isFromGrpWorklist: boolean = false;
  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: customData,
    public dialogRef: MatDialogRef<DgDisposeComponent>
  ) {}
  expForm: FormGroup;
  ngOnInit(): void {
    this.caseData = this.data?.selectedData;
    this.checkDispose = this.data?.defaultData ? this.data?.defaultData : true;
    this.isFromGrpWorklist = this.data?.isFromGrpWorklist;
    this.expForm = new FormGroup({
      reason: new FormControl(null, [Validators.pattern(/^[^#]+$/)]),
    });
  }

  formInvalid() {
    return this.expForm.invalid;
  }
  onDispose(): void {
    this.postData = [];
    if (this.expForm.valid || !this.checkDispose) {
      this.caseData = this.data?.selectedData;
      this.caseData.forEach((ele) => {
        this.docId = ele.docId;
        this.appTypeID = ele.appTypeId;
        this.postData.push({
          recID: this.docId,
          appTypeID: this.appTypeID,
          finalDecision: this.str?.length > 0 ? this.str : 'Case Disposed',
          remarks: this.str?.length > 0 ? this.str : 'Case Disposed',
          docDetailVO: ele.docDetailVO,
        });
      });

      if (!this.data?.isFromCustomAction) {
        if (this.isFromGrpWorklist) {
          this.http
            .post(
              '/case-mgmnt/dispose-case-with-pull-to-worklist',
              this.postData
            )
            .subscribe((res) => {
              this.dialogRef.close(true);
            });
        } else {
          this.http
            .post('/case-mgmnt/dispose-case', this.postData)
            .subscribe((res) => {
              this.dialogRef.close(true);
            });
        }
      } else {
        let data = [];
        this.postData?.forEach((ele) => {
          let json = {
            recID: Number(ele?.recID),
            appTypeID: Number(ele?.appTypeId),
            finalDecision: ele?.finalDecision,
            remarks: ele?.remarks,
          };
          data?.push(json);
        });
        this.dialogRef.close(data);
      }
    }
  }
}
